var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import FunnelGenderImageSrc from '@images/marketing/funnel/Funnel-Gender-Page.jpg';
import { useProfileContext } from '@marketing/profile/ProfileContext';
import { ProfilePageLayout, ProfilePageMain } from '@marketing/profile/common/ProfilePageLayout';
import { useNavigate } from 'react-router';
var PetGenderPage = function () {
    var navigate = useNavigate();
    var _a = useProfileContext(), currentPet = _a.currentPet, currentPetIndex = _a.currentPetIndex, profileBasePath = _a.profileBasePath, sendFunnelGTMEvent = _a.sendFunnelGTMEvent;
    var handleClickPrevious = function () {
        navigate("".concat(profileBasePath, "/pet/").concat(currentPetIndex, "/name"));
    };
    var handleClickNext = function () {
        sendFunnelGTMEvent('click-next_gender_stop');
        navigate("".concat(profileBasePath, "/pet/").concat(currentPetIndex, "/gender"), { viewTransition: true });
    };
    return (_jsx(ProfilePageLayout, __assign({ handleClickNext: handleClickNext, handleClickPrevious: handleClickPrevious }, { children: _jsxs(ProfilePageMain, __assign({ heading: "Next up: Gender", imageData: { src: FunnelGenderImageSrc, alt: 'Dog tongue blep' } }, { children: ["Believe it or not, this can tell us about ", currentPet.name, "\u2019s ideal weight range and a whole lot more."] })) })));
};
export default PetGenderPage;
